import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { QA_NAME_EXTRA_BTN } from '../../../constants/qa'
import Button from '../../Button'

import * as styles from './FormButtonAdd.module.css'

import PlusIcon from '../../../icons/plus.svg'

function FormButtonAdd({
  Component = Button.Text,
  beforeIconProps: { Icon = PlusIcon, ...beforeIconProps } = EMPTY_OBJECT,
  className = styles.FormButtonAdd,
  qaName = QA_NAME_EXTRA_BTN,
  title,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Component
      {...restProps}
      beforeIconProps={{ ...beforeIconProps, Icon }}
      className={className}
      qaName={qaName}
      text={t(title)}
    />
  )
}

export default FormButtonAdd
